import { FC, useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import { DSButton, DSDialog, DSHeading, DSText } from '@stihl-design-system/components';

import { addToolErrorEvent } from '@phoenix/team-m/my-tool-shed/frontend/shared/tracking/add-tool.events';
import { useSearchTools } from '@phoenix/team-m/my-tool-shed/frontend/shared/use-search-tools';

export const ToolsNotFoundModal: FC = () => {
  const { t } = useTranslation();
  const { toolsFound, resetSearchTools: reset, isRemoved } = useSearchTools();

  const showDialog = !isRemoved && toolsFound?.length === 0;

  useEffect(() => {
    showDialog && addToolErrorEvent.registeredProductNotFound();
  }, [showDialog]);

  return (
    <DSDialog
      isOpen={showDialog}
      onClose={reset}
      header={<DSHeading tag="h3">{t('addTool_entry_option_search_noToolFound_headline')}</DSHeading>}
      footer={
        <DSButton type="button" onClick={reset} variant="outline" data-testid="accept-button">
          {t('addTool_entry_option_search_noToolFound_button_okay')}
        </DSButton>
      }
      data-testid="no-products-found-modal"
    >
      <DSText>{t('addTool_entry_option_search_noToolFound_body')}</DSText>
    </DSDialog>
  );
};
